import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] bg-cs-dark text-white px-4 py-4 shadow-2xl border-t border-white/10">
      <div className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 text-sm text-gray-400 leading-relaxed">
           <span className="font-semibold text-white">🍪 Cookies & Confidentialité</span>
           {' '}Nous utilisons des cookies essentiels pour le bon fonctionnement du site (panier, session).{' '}
           <Link to="/politique-confidentialite" className="text-blue-400 hover:underline underline-offset-2 font-medium">
             En savoir plus
           </Link>
         </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={refuse}
            className="px-4 py-2 text-sm border border-white/30 text-white rounded hover:bg-white/10 transition-colors font-medium"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 text-sm bg-cs-blue text-white rounded font-semibold hover:bg-cs-blue-dark transition-colors"
          >
            Accepter
          </button>
          <button onClick={refuse} aria-label="Fermer" className="p-1 text-gray-400 hover:text-white transition-colors ml-1">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}